<template>
  <div class="container-box">
    <div
      class="compilation-list scroll-container"
      v-if="courseList.length > 0 && pageLoadingComplete"
    >
      <div
        class="compilation-item"
        @click="goDetail(item)"
        v-for="(item, index) in courseList"
        :key="index"
      >
        <div class="title">{{ item.name }}</div>
        <div class="fonts">
          <div class="left">{{ item.summary }}</div>
          <div class="right" v-if="item.usability == 'product'">
            <div class="money">
              ￥
              <span class="">{{ item.product.price }}</span>
            </div>
          </div>
          <div class="right" v-if="item.usability == 'free'">
            <div class="money">免费</div>
          </div>
          <div class="right" v-if="item.usability == 'identity'">
            <div class="money">购买功能包</div>
          </div>
        </div>
      </div>
    </div>
    <van-empty
      v-if="pageLoadingComplete && courseList.length == 0"
      description="没有找到对应题集"
    />
    <!-- 侧边打开APP悬浮按钮(停售且未购买时不显示) -->
    <SideOpenApp
      v-if="courseList"
      unitKey="QuestionSetTag"
      :options="{ tag: queryParams && queryParams.tag }"
    />
  </div>
</template>

<script>
import { getCompilation } from '@/api/goods/detail'
import SideOpenApp from '@/components/SideOpenApp.vue'
export default {
  name: 'Compilation',
  components: {
    SideOpenApp,
  },
  data() {
    return {
      courseList: [], // 你的数据数组
      isLoading: true, // 是否正在加载
      queryParams: {
        brand: '',
        province: '',
        tag: '',
        page: 1,
        pageSize: 20,
      },
      pageLoadingComplete: false,
      tag: '',
    }
  },
  created() {
    window.addEventListener('scroll', this.watchScroll)
  },
  mounted() {
    this.queryParams.brand = this.$route.query.brand
    this.queryParams.province = this.$route.query.province
    this.queryParams.tag = this.$route.query.tag
    this.getCourseList()
  },
  methods: {
    goDetail(item) {
      let query = {
        province: this.$route.query.province,
        brand: this.$route.query.brand,
        no: item.no,
      }
      this.$router.push({
        path: '/question/detail',
        query: query,
      })
    },
    getCourseList() {
      getCompilation({ ...this.queryParams }).then((res) => {
        this.pageLoadingComplete = true
        this.courseList = res?.data?.list
      })
    },
    watchScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let clientHeight = document.documentElement.clientHeight
      let scrollHeight = document.documentElement.scrollHeight
      if (scrollTop + clientHeight >= scrollHeight) {
        this.queryParams.page += 1
        if (!this.isLoading) return
        getCompilation({ ...this.queryParams }).then((res) => {
          if (res.data.list.length == 0) {
            this.isLoading = false
          } else {
            this.isLoading = true
            this.courseList = this.courseList.concat(res.data.list)
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.container-box {
  padding: 0 0.53rem;
  min-height: 100vh;
  // background: #fff;
}

.compilation-list {
  padding-top: 0.43rem;

  .compilation-item {
    padding: 0.32rem 0.43rem;
    // border-bottom: 1px solid #EBECF0;
    background: #fff;
    margin-bottom: 0.29rem;
    border-radius: 0.21rem;

    .title {
      font-size: 0.4rem;
      color: #3c3d42;
      // font-weight: bold;
    }

    .fonts {
      display: flex;
      align-items: center;
      margin-top: 0.35rem;

      .left {
        font-size: 0.37rem;
        color: #919499;
        flex: 1;
        min-width: 0;
        padding-right: 1rem;
        @include ellipsis;
      }

      .right {
        display: flex;
        align-items: center;

        .money-gray {
          font-size: 0.37rem;
          color: #919499;
          text-decoration: line-through;
          margin-right: 0.08rem;

          span {
            font-size: 0.32rem;
          }
        }

        .money {
          color: var(--main-color);
          font-weight: bold;

          span {
            font-size: 0.32rem;
          }
        }
      }
    }
  }
}
</style>
